import { ModalLayout } from '@/components/ModalLayout'
import { TaskHeaderLeft } from '@/components/TaskHeaderLeft'
import { UserDetail } from '@/uikit/UserManagement'
import { State } from '@seiue/ui'
import {
  FieldDomainEnum,
  ReflectionRoleEnum,
  reflectionApi,
} from 'packages/sdks-next/growp'

/**
 *  用户详情
 *
 * @param param - 参数
 * @param param.onClose - 关闭
 * @param param.rid - 用户 ID
 * @param param.role - 用户角色
 * @param param.isArchived - 用户是否已离校
 * @returns 组件
 */
export const UserDetailModal: React.FC<{
  onClose?: () => void
  rid: number
  role: string
  isArchived?: boolean
}> = ({ onClose, rid, role, isArchived }) => {
  const { data: student, loading: loadStudent } = reflectionApi.useLoadStudent(
    {
      id: rid,
      query: {
        expand: ['fields', 'guardians'],
      },
    },
    { disable: role !== ReflectionRoleEnum.Student }
  )

  const { data: teacher, loading: loadTeacher } = reflectionApi.useLoadTeacher(
    {
      id: rid,
      query: {
        expand: ['fields', 'guardians'],
      },
    },
    { disable: role !== ReflectionRoleEnum.Teacher }
  )

  const { api: updateStudentInfo } = reflectionApi.useUpdateStudent({
    reload: [reflectionApi.loadStudent],
  })

  const { api: updateTeacherInfo } = reflectionApi.useUpdateTeacher({
    reload: [reflectionApi.loadTeacher],
  })

  return (
    <ModalLayout
      title={
        <TaskHeaderLeft
          title={'个人档案'}
          onClose={onClose}
        />
      }
      hiddenHeader={!!isArchived}
      contentStyle={{
        padding: '20px 240px',
        height: 'calc(100vh - 72px)',
        overflow: 'auto',
      }}
      content={
        loadStudent || loadTeacher ? (
          <State.Loading />
        ) : (
          <UserDetail
            id={rid}
            domain={
              role === ReflectionRoleEnum.Student
                ? FieldDomainEnum.FormalStudent
                : FieldDomainEnum.FormalTeacher
            }
            data={role === ReflectionRoleEnum.Student ? student : teacher}
            updateInfo={
              role === ReflectionRoleEnum.Student
                ? updateStudentInfo
                : updateTeacherInfo
            }
            isOwner={true}
          />
        )
      }
    />
  )
}
